import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
const faqs = [{
  q: 'How much does a custom engagement ring cost?',
  a: "Most of our custom engagement rings sit between $5,000 and $15,000, with simpler designs starting from around $3,500. We give you a firm written quote before any work begins, and we'll always tell you honestly if your idea can be made for less. [VERIFY pricing with client]"
}, {
  q: 'Do you make custom engagement rings in Perth?',
  a: 'Yes. We design and handcraft custom engagement rings on-site in our Ardross workshop. The process includes diamond selection, design concepts, a CAD model, and a wearable 3D resin proof — so you see and feel the ring before we ever cast it in metal.'
}, {
  q: 'Can I remodel old jewellery into a new piece?',
  a: "Yes — heirloom remodelling is one of our most loved services. We can melt down inherited gold and reset existing diamonds or gemstones into a new design that carries the same sentimental weight in a piece you'll actually wear."
}, {
  q: 'How long do repairs take?',
  a: "Most repairs — sizing, claw tips, chains, polishing — are returned within 7 days. More complex restorations or remodels take 4–6 weeks. We'll give you a realistic timeframe at the consultation and stick to it."
}, {
  q: 'Can you help me choose a diamond?',
  a: "Yes. We source GIA certified, conflict-free diamonds to your specific brief and budget. We'll explain cut, colour, clarity and carat in plain language — including which factors are worth paying more for and which aren't."
}, {
  q: 'Do you use CAD or 3D design?',
  a: 'Yes — for custom designs and complex remodels we produce a CAD model and a 3D resin proof. You can hold and try the proof before we begin manufacturing in metal, so there are no surprises in the final piece.'
}, {
  q: 'Do you provide jewellery valuations?',
  a: "Yes — our valuations are NCJV-accredited and suitable for insurance purposes or probate. You'll receive a detailed technical report with high-resolution photographs and a current replacement value."
}, {
  q: 'Do I need to know exactly what I want?',
  a: "Not at all. Many of our clients arrive with nothing more than a feeling. We start with a quiet, no-pressure conversation, show you examples, and help you work out the direction together. There's no wrong way to begin."
}, {
  q: 'Can I bring in photos or Pinterest inspiration?',
  a: "Yes, please do. Sketches, screenshots, Pinterest boards — anything that helps us understand the look you're drawn to is genuinely useful. We use them as a starting point and build something uniquely yours from there."
}, {
  q: 'Will my old stones and gold be reused?',
  a: "Wherever possible, yes. We assess your existing materials, advise on what's suitable to reuse, and recycle the rest. Many of our most meaningful remodels are made entirely from a client's inherited gold and stones."
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="section-padding bg-paper border-y border-gold/15" data-id="element-188">
      <div className="container-custom max-w-4xl" data-id="element-189">
        <div className="mb-12" data-id="element-190">
          <span className="eyebrow" data-id="element-191">Direct answers</span>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-medium leading-[1.1] text-balance" data-id="element-192">
            The questions{' '}
            <span className="italic text-gold-dark" data-id="element-193">
              most people ask first.
            </span>
          </h2>
        </div>

        <div className="border-t border-gold/20" data-id="element-194">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className="border-b border-gold/20" data-id="element-195">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full flex items-start justify-between gap-6 py-6 text-left focus:outline-none group" aria-expanded={isOpen} data-id="element-196">
                  <h3 className="font-serif text-lg md:text-xl text-primary leading-snug group-hover:text-gold-dark transition-colors" data-id="element-197">
                    {faq.q}
                  </h3>
                  <span className={`shrink-0 w-8 h-8 rounded-full border border-gold/30 flex items-center justify-center transition-all duration-300 ${isOpen ? 'bg-gold border-gold rotate-45' : 'bg-transparent'}`} data-id="element-198">
                    <PlusIcon className={`w-4 h-4 transition-colors ${isOpen ? 'text-white' : 'text-gold'}`} data-id="element-199" />
                  </span>
                </button>

                <AnimatePresence data-id="element-200">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} className="overflow-hidden" data-id="element-201">
                      <p className="text-secondary leading-relaxed pb-6 pr-12 text-pretty" data-id="element-202">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}